import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import moment from "moment";


class MailLogs extends Component {


    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            isLoading: false,
            alert: null,
            mails: null,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.fetchMails = this.fetchMails.bind(this);
    }

    fetchMails(accessor, direction, page, size) {

        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/mail-log/fetchMailLogs?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({isLoading: true, searching: true});
        request(params).then(function (response) {
            self.setState({
                mails: response.data.content,
                page: page,
                size: size,
                total: response.data.totalElements,
                isLoading: false,
                searching: false
            });
        }).catch(function (error) {
            self.setState({isLoading: false, searching: false});
            showAxiosError(error);
        });
    }


    handleLogout() {
        this.props.handleLogout();

    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchMails(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    render() {
        const isSendSelectData = [{value: null, label: "Tümü"}, {value: "true", label: "Başarılı"}, {
            value: "false",
            label: "Başarısız"
        }];
        const columns = [
            {
                Header: "Oluşturma Tarihi",
                accessor: "createdDate",
                Cell: item => (
                    <label>{item.createdDate ? moment.utc(item.createdDate).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },
            {
                Header: "Kullanıcı Adı",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <label>{item.user && item.user.username}</label>
                )
            },
            {
                Header: "Alıcı Mail Adresi",
                accessor: "to",
                sortable: false,
            },

            {
                Header: "Gönderi Tarihi",
                accessor: "sendDate",
                Cell: item => (
                    <label>{item.sendDate ? moment.utc(item.sendDate).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },
            {
                Header: "Gönderim",
                accessor: "send",
                sortable: false,
                Cell: item => (
                    <label>{item.send === true ? "Başarılı" : "Başarısız"}</label>
                )
            }
        ];

        const fields = [

            {
                label: "Kullanıcı Adı",
                accessor: "user.username",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Mail Adresi",
                accessor: "to",
                type: "text",
                operator: "=",
            },
            {
                label: "Oluşturma Tarihi",
                accessor: "createdDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "Gönderi Tarihi",
                accessor: "sendDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "Göderi Durumu",
                accessor: "send",
                type: "select",
                operator: "=",
                selectData: isSendSelectData,
            },
        ];

        return (

            /*this.props.currentUser.realm === 0 && */
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        {
                            <h4 className="card-title">Gönderilen Mail Logları</h4>
                        }
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            columns={columns}
                            content={this.state.mails ? this.state.mails : []}
                            total={this.state.total}
                            page={this.state.page}
                            size={this.state.size}
                            loading={this.state.isLoading}
                            options={['5', '10', '20']}
                            fetchData={this.fetchMails}
                            style={{width:"100%"}}
                        />
                    </div>

                    {/*<button type="button"
                            onClick={() => this.createMailForTest()}
                            data-toggle="tooltip" data-placement="bottom" title="test"
                            style={{background: 'linear-gradient( rgb(241, 241, 37), rgb(220, 214, 8))'}}
                            rel="tooltip" className="Btn btn-sm btn-icon"> mail
                    </button>*/}
                </div>
            </div>
        )
    }
}

export default MailLogs


// WEBPACK FOOTER //
// ./src/page/mailLogs/MailLogs.js